import { IconAddPlus } from '@components/icons/add-plus';
import { Menu } from '@components/menu';
import { SelectOption } from '@components/select';
import { useScopedTranslate } from '@locale/translate';

import { locale } from '../field-mapping-sidebar';

type Props = {
  options: SelectOption[];
  selectedValues: string[];
  onManualMultiSelect: (option: SelectOption) => void;
};

export const SelectMultiManualField = ({ options, selectedValues, onManualMultiSelect }: Props) => {
  const { t } = useScopedTranslate(locale);
  const available = options.filter((option) => !selectedValues.includes(option.value));

  if (available.length === 0) return null;

  return (
    <Menu
      placement="bottom-start"
      buttonProps={{
        iconLeft: <IconAddPlus />,
        variant: 'secondary',
        text: t('manuallySelectValue'),
      }}
    >
      {available.map((option) => (
        <Menu.Item
          key={`${option.value}-${option.label}`}
          label={option.label}
          selectionType="open"
          onSelect={() => onManualMultiSelect(option)}
        />
      ))}
    </Menu>
  );
};
